import { Box } from '@mui/material';

const ASSETS = {
  full: '/logo-full.png',
  icon: '/logo-icon.png',
};

export default function DineoLogo({
  variant = 'full',
  height = 28,
  className,
  sx,
}) {
  return (
    <Box
      component="img"
      src={ASSETS[variant]}
      alt="Dineo"
      className={className}
      sx={[
        {
          height,
          width: 'auto',
          display: 'block',
          objectFit: 'contain',
        },
        (theme) =>
          theme.applyStyles('dark', {
            filter: 'brightness(0) invert(1)',
          }),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    />
  );
}
